import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { cx } from '@emotion/css';
import { Box, useMediaQuery } from '@mui/material';

import { NavBarCloseButton } from '@/design-system';
import styles from './Drawer.styles';

interface DrawerProps {
  title: React.ReactNode;
  titleId?: string;
  isOpen: boolean;
  children: React.ReactNode;
  anchor?: 'top' | 'right' | 'left' | 'bottom';
  onToggle: (open: boolean) => void;
  full?: boolean;
}

export const Drawer: React.FC<DrawerProps> = ({
  title,
  titleId = 'drawer-title',
  isOpen,
  onToggle,
  children,
  anchor = 'bottom',
  full,
}) => {
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const transitionDuration = prefersReducedMotion ? 0 : undefined;
  const handleToggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    onToggle(open);
  };

  return (
    <SwipeableDrawer
      className={cx(styles.container && full && styles.full)}
      anchor={anchor}
      open={isOpen}
      onClose={handleToggleDrawer(false)}
      onOpen={handleToggleDrawer(true)}
      disableSwipeToOpen
      data-testid="optionsContainer"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      ModalProps={{
        keepMounted: true,
      }}
      transitionDuration={transitionDuration}
    >
      <Box
        sx={{ width: 'auto' }}
        className={styles.stickyHeader}
        tabIndex={-1}
        onClick={handleToggleDrawer(false)}
        onKeyDown={handleToggleDrawer(false)}
      >
        <h1 id={titleId} className='visually-hidden'>{title}</h1>
        <NavBarCloseButton buttonPosition="right" aria-haspopup="dialog">
          {title}
        </NavBarCloseButton>
      </Box>
      <div className={full ? styles.fullList : styles.list} data-testid="optionsList">
        {children}
      </div>
    </SwipeableDrawer>
  );
};
